const deviceMap = {
    'mobile-app': 'mobile',
    'tablet-app': 'tablet',
};

const normalizeDevice = (device) => deviceMap[device] || device;

export default normalizeDevice;



/** WEBPACK FOOTER **
 ** ./src/utils/normalize-device.js
 **/